import React from "react";
import CloseIcon from "@mui/icons-material/Close";

import { CSSTransition } from "react-transition-group";
import "./modal.css";

const ModalComponent = ({
  showModal,
  show,
  children,
  title,
  subtitle,
  style,
}) => {
  return (
    <>
      <CSSTransition in={show} unmountOnExit timeout={{ enter: 0, exit: 300 }}>
        <div
          className="modal 
                    bg-[#344335]
                    bg-opacity-50 fixed inset-0 z-50 w-full h-full
                    opacity-0 transition-all duration-[0.3s] flex items-center justify-center"
          onClick={showModal}
        >
          <div
            style={style}
            className="relative p-4 w-full max-w-xl modal-content translate-y-[-200px] transition-all duration-[0.3s]"
            onClick={(e) => e.stopPropagation()}
          >
            {/* modal content */}
            <div className="relative bg-white rounded-lg py-4 px-5 max-h-[90vh] overflow-y-auto">
              {/* modal header */}
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="text-base font-semibold text-[#344335]">
                    {title}
                  </h3>
                  <p className="text-[#96A397] text-xs font-medium mt-4">
                    {subtitle}
                  </p>
                </div>

                <div className="cursor-pointer" onClick={showModal}>
                  <CloseIcon />
                </div>
              </div>

              {/* modal body */}
              <div>{children}</div>
            </div>
          </div>
        </div>
      </CSSTransition>
    </>
  );
};

export default ModalComponent;
